"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var react_ace_1 = require("react-ace");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var Handlebars = require("handlebars");
var GwsGameProviderCfgEditor = /** @class */ (function (_super) {
    __extends(GwsGameProviderCfgEditor, _super);
    function GwsGameProviderCfgEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        //private readonly key_import = "import";
        _this.key_test = "test";
        return _this;
    }
    GwsGameProviderCfgEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.recordKey != null) {
            this.props.data.LoadData(this.props.recordKey.key, function () {
                _this.setState({
                    frontend_api_url: _this.props.data.DATA.frontend_api_url,
                    plugin_api_url: _this.props.data.DATA.plugin_api_url,
                    plugin_api_pwd_hash: _this.props.data.DATA.plugin_api_pwd_hash,
                    cdn_baseurl: _this.props.data.DATA.cdn_baseurl,
                    game_money_template_url_desktop: _this.props.data.DATA.game_money_template_url_desktop,
                    game_demo_template_url_desktop: _this.props.data.DATA.game_demo_template_url_desktop,
                    //game_bonus_template_url_desktop: this.props.data.DATA.game_bonus_template_url_desktop,
                    game_money_template_url_mobile: _this.props.data.DATA.game_money_template_url_mobile,
                    game_demo_template_url_mobile: _this.props.data.DATA.game_demo_template_url_mobile,
                    //game_bonus_template_url_mobile: this.props.data.DATA.game_bonus_template_url_mobile,
                    logo_width_0: _this.props.data.DATA.logo_width,
                    logo_height_0: _this.props.data.DATA.logo_height,
                    logo_width_1: _this.props.data.DATA.logo_width_1,
                    logo_height_1: _this.props.data.DATA.logo_height_1,
                    //streamer_operator_id: this.props.data.DATA.streamer_operator_id,
                    money_operator_id: _this.props.data.DATA.money_operator_id,
                    template_test: _this.props.data.DATA.template_url_test_data,
                });
            });
        }
        this.setState({
            frontend_api_url: "",
            plugin_api_url: "",
            plugin_api_pwd_hash: "",
            cdn_baseurl: "",
            game_money_template_url_desktop: "",
            game_demo_template_url_desktop: "",
            //game_bonus_template_url_desktop: "",
            game_money_template_url_mobile: "",
            game_demo_template_url_mobile: "",
            //game_bonus_template_url_mobile: "",
            logo_width_0: 0,
            logo_height_0: 0,
            logo_width_1: 0,
            logo_height_1: 0,
            //bonus_operator_id: "",
            money_operator_id: "",
            template_test: "{}",
            //ngm_is_new_flag: false,
            //ngm_wager_percent: 0,
            //ngm_withdraw_percent: 0,
            //ngm_jackpot_percent: 0,
            //ngm_tournament_percent: 0,
            //ngm_points_percent: 0,
            //ngm_levels_percent: 0,
            tabKey: this.key_main
        });
        this.doReSetRules();
        this.props.state.setExtBreadCrumbPath(["Настройка параметров шлюза"]);
    };
    GwsGameProviderCfgEditor.prototype.doReSetRules = function () {
        this.setState({
            frontend_api_url_rules: { isError: false },
            plugin_api_url_rules: { isError: false },
            plugin_api_pwd_hash_rules: { isError: false },
            cdn_baseurl_rules: { isError: false },
            logo_width_rules_0: { isError: false },
            logo_height_rules_0: { isError: false },
            logo_width_rules_1: { isError: false },
            logo_height_rules_1: { isError: false },
            game_demo_template_url_desktop_rules: { isError: false },
            game_money_template_url_desktop_rules: { isError: false },
            //game_bonus_template_url_desktop_rules: { isError: false },
            game_demo_template_url_mobile_rules: { isError: false },
            game_money_template_url_mobile_rules: { isError: false },
            //game_bonus_template_url_mobile_rules: { isError: false },
            //streamer_operator_id_rules: { isError: false },
            money_operator_id_rules: { isError: false },
        });
    };
    GwsGameProviderCfgEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                gws_gameprovider_id: this.props.recordKey.key,
                frontend_api_url: this.state.frontend_api_url,
                plugin_api_url: this.state.plugin_api_url,
                plugin_api_pwd_hash: this.state.plugin_api_pwd_hash,
                cdn_baseurl: this.state.cdn_baseurl,
                game_money_template_url_desktop: this.state.game_money_template_url_desktop,
                game_demo_template_url_desktop: this.state.game_demo_template_url_desktop,
                //game_bonus_template_url_desktop: this.state.game_bonus_template_url_desktop,
                game_money_template_url_mobile: this.state.game_money_template_url_mobile,
                game_demo_template_url_mobile: this.state.game_demo_template_url_mobile,
                //game_bonus_template_url_mobile: this.state.game_bonus_template_url_mobile,
                logo_width: this.state.logo_width_0,
                logo_height: this.state.logo_height_0,
                logo_width_1: this.state.logo_width_1,
                logo_height_1: this.state.logo_height_1,
                //streamer_operator_id: this.state.streamer_operator_id,
                money_operator_id: this.state.money_operator_id,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Настройки геймпровайдера изменены!");
            });
        }
    };
    GwsGameProviderCfgEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    GwsGameProviderCfgEditor.prototype.getFormTitle = function () {
        return "Изменить настройки геймпровайдера";
    };
    GwsGameProviderCfgEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.frontend_api_url) || (this.state.frontend_api_url.length === 0)) {
            this.setState({
                frontend_api_url_rules: { isError: true, errorMessage: "Поле [frontend_api_url] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.plugin_api_url) || (this.state.plugin_api_url.length === 0)) {
            this.setState({
                plugin_api_url_rules: { isError: true, errorMessage: "Поле [plugin_api_url] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.plugin_api_pwd_hash) || (this.state.plugin_api_pwd_hash.length === 0)) {
            this.setState({
                plugin_api_pwd_hash_rules: { isError: true, errorMessage: "Поле [plugin_api_pwd_hash] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.cdn_baseurl) || (this.state.cdn_baseurl.length === 0)) {
            this.setState({
                cdn_baseurl_rules: { isError: true, errorMessage: "Поле [cdn_baseurl] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.game_money_template_url_desktop) || (this.state.game_money_template_url_desktop.length === 0)) {
            this.setState({
                game_money_template_url_desktop_rules: { isError: true, errorMessage: "Поле [game_money_template_url_desktop] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        //if ((!this.state.game_bonus_template_url_desktop) || (this.state.game_bonus_template_url_desktop.length === 0)) {
        //    this.setState({
        //        game_bonus_template_url_desktop_rules: { isError: true, errorMessage: "Поле [game_bonus_url_template_desktop] не заполнено!" },
        //        tabKey: this.key_additional
        //    })
        //    return false;
        //}
        if ((!this.state.game_demo_template_url_desktop) || (this.state.game_demo_template_url_desktop.length === 0)) {
            this.setState({
                game_demo_template_url_desktop_rules: { isError: true, errorMessage: "Поле [game_demo_template_url_desktop] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if ((!this.state.game_money_template_url_mobile) || (this.state.game_money_template_url_mobile.length === 0)) {
            this.setState({
                game_money_template_url_mobile_rules: { isError: true, errorMessage: "Поле [game_money_template_url_mobile] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        //if ((!this.state.game_bonus_template_url_mobile) || (this.state.game_bonus_template_url_mobile.length === 0)) {
        //    this.setState({
        //        game_bonus_template_url_mobile_rules: { isError: true, errorMessage: "Поле [game_bonus_url_template_mobile] не заполнено!" },
        //        tabKey: this.key_additional
        //    })
        //    return false;
        //}
        if ((!this.state.game_demo_template_url_mobile) || (this.state.game_demo_template_url_mobile.length === 0)) {
            this.setState({
                game_demo_template_url_mobile_rules: { isError: true, errorMessage: "Поле [game_demo_template_url_mobile] не заполнено!" },
                tabKey: this.key_additional
            });
            return false;
        }
        if ((!this.state.logo_width_0) || (isNaN(this.state.logo_width_0))) {
            this.setState({
                logo_width_rules_0: { isError: true, errorMessage: "Поле [ширина логотипа] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        else {
            if ((this.state.logo_width_0 < 100) || (this.state.logo_width_0 > 1000)) {
                this.setState({
                    logo_width_rules_0: { isError: true, errorMessage: "Поле [ширина логотипа] имеет недопустимое значение" },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        if ((!this.state.logo_height_0) || (isNaN(this.state.logo_height_0))) {
            this.setState({
                logo_height_rules_0: { isError: true, errorMessage: "Поле [высота логотипа] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        else {
            if ((this.state.logo_height_0 < 100) || (this.state.logo_height_0 > 1000)) {
                this.setState({
                    logo_height_rules_0: { isError: true, errorMessage: "Поле [высота логотипа] имеет недопустимое значение" },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        //----------------------------------------------------------------------------------------------------------------------
        if ((!this.state.logo_width_1) || (isNaN(this.state.logo_width_1))) {
            this.setState({
                logo_width_rules_1: { isError: true, errorMessage: "Поле [ширина логотипа] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        else {
            if ((this.state.logo_width_1 < 100) || (this.state.logo_width_1 > 1000)) {
                this.setState({
                    logo_width_rules_1: { isError: true, errorMessage: "Поле [ширина логотипа] имеет недопустимое значение" },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        if ((!this.state.logo_height_1) || (isNaN(this.state.logo_height_1))) {
            this.setState({
                logo_height_rules_1: { isError: true, errorMessage: "Поле [высота логотипа] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        else {
            if ((this.state.logo_height_1 < 100) || (this.state.logo_height_1 > 1000)) {
                this.setState({
                    logo_height_rules_1: { isError: true, errorMessage: "Поле [высота логотипа] имеет недопустимое значение" },
                    tabKey: this.key_main
                });
                return false;
            }
        }
        //if ((!this.state.streamer_operator_id) || (this.state.streamer_operator_id.length <= 0)) {
        //    this.setState({
        //        streamer_operator_id_rules: { isError: true, errorMessage: "Поле [оператор ид <стример>] не заполнено!" },
        //        tabKey: this.key_main
        //    })
        //   return false;
        //}
        if ((!this.state.money_operator_id) || (this.state.money_operator_id.length <= 0)) {
            this.setState({
                money_operator_id_rules: { isError: true, errorMessage: "Поле [оператор ид <деньги>] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        //if ((this.state.ngm_wager_percent < 0) || (this.state.ngm_wager_percent > 100)) {
        //    this.setState({
        //        ngm_wager_percent_rules: {
        //            isError: true, errorMessage: "Поле процент в вейджер не заполнен"
        //        },
        //        tabKey: this.key_import
        //    })
        //    return false;
        //}
        //if ((this.state.ngm_withdraw_percent < 0) || (this.state.ngm_withdraw_percent > 100)) {
        //    this.setState({
        //        ngm_withdraw_percent_rules: {
        //            isError: true, errorMessage: "Поле процент в снятие не заполнено"
        //        },
        //        tabKey: this.key_import
        //    })
        //    return false;
        //}
        //if ((this.state.ngm_jackpot_percent < 0) || (this.state.ngm_jackpot_percent > 100)) {
        //    this.setState({
        //        ngm_jackpot_percent_rules: {
        //            isError: true, errorMessage: "Поле процент в джекпот не заполнено"
        //        },
        //        tabKey: this.key_import
        //    })
        //    return false;
        //}
        //if ((this.state.ngm_tournament_percent < 0) || (this.state.ngm_tournament_percent > 100)) {
        //    this.setState({
        //        ngm_tournament_percent_rules: {
        //            isError: true, errorMessage: "Поле процент в турнир не заполнено"
        //        },
        //        tabKey: this.key_import
        //    })
        //    return false;
        //}
        //if ((this.state.ngm_points_percent < 0) || (this.state.ngm_points_percent > 100)) {
        //    this.setState({
        //        ngm_points_percent_rules: {
        //            isError: true, errorMessage: "Поле процент в пойнты не заполнено"
        //        },
        //        tabKey: this.key_import
        //    })
        //    return false;
        //}
        //if ((this.state.ngm_levels_percent < 0) || (this.state.ngm_levels_percent > 100)) {
        //    this.setState({
        //        ngm_levels_percent_rules: {
        //            isError: true, errorMessage: "Поле процент в уровни не заполнено"
        //        },
        //        tabKey: this.key_import
        //    })
        //    return false;
        //}
        return true;
    };
    GwsGameProviderCfgEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    GwsGameProviderCfgEditor.prototype.getMainTabRenderObject = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Frontend api url:", placeholder: "Введите Frontend api url" }, value: this.state.frontend_api_url, onValueChanged: function (newVal) {
                    _this.setState({
                        frontend_api_url: newVal,
                        frontend_api_url_rules: { isError: false }
                    });
                }, required: true, rules: this.state.frontend_api_url_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Plugin api url:", placeholder: "Введите Plugin api url" }, value: this.state.plugin_api_url, onValueChanged: function (newVal) {
                    _this.setState({
                        plugin_api_url: newVal,
                        plugin_api_url_rules: { isError: false }
                    });
                }, required: true, rules: this.state.plugin_api_url_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Plugin api pwd sha1:", placeholder: "Введите Plugin api pwd sha1" }, value: this.state.plugin_api_pwd_hash, onValueChanged: function (newVal) {
                    _this.setState({
                        plugin_api_pwd_hash: newVal,
                        plugin_api_pwd_hash_rules: { isError: false }
                    });
                }, required: true, rules: this.state.plugin_api_pwd_hash_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "CDN url:", placeholder: "Введите CDN url" }, value: this.state.cdn_baseurl, onValueChanged: function (newVal) {
                    _this.setState({
                        cdn_baseurl: newVal,
                        cdn_baseurl_rules: { isError: false }
                    });
                }, required: true, rules: this.state.cdn_baseurl_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Ширина лого(0):", placeholder: "Введите ширину лого(0)" }, values: { max: 1000, min: 100, value: this.state.logo_width_0 }, onValueChanged: function (newVal) {
                    _this.setState({
                        logo_width_0: newVal,
                        logo_width_rules_0: { isError: false }
                    });
                }, required: true, rules: this.state.logo_width_rules_0 }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Высота лого(0):", placeholder: "Введите высоту лого(0)" }, values: { max: 1000, min: 100, value: this.state.logo_height_0 }, onValueChanged: function (newVal) {
                    _this.setState({
                        logo_height_0: newVal,
                        logo_height_rules_0: { isError: false }
                    });
                }, required: true, rules: this.state.logo_width_rules_0 }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Ширина лого(1):", placeholder: "Введите ширину лого(1)" }, values: { max: 1000, min: 100, value: this.state.logo_width_1 }, onValueChanged: function (newVal) {
                    _this.setState({
                        logo_width_1: newVal,
                        logo_width_rules_1: { isError: false }
                    });
                }, required: true, rules: this.state.logo_width_rules_1 }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Высота лого(1):", placeholder: "Введите высоту лого(1)" }, values: { max: 1000, min: 100, value: this.state.logo_height_1 }, onValueChanged: function (newVal) {
                    _this.setState({
                        logo_height_1: newVal,
                        logo_height_rules_1: { isError: false }
                    });
                }, required: true, rules: this.state.logo_width_rules_1 }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Money operator id:", placeholder: "Введите money operator id" }, value: this.state.money_operator_id, onValueChanged: function (newVal) {
                    _this.setState({
                        money_operator_id: newVal,
                        money_operator_id_rules: { isError: false }
                    });
                }, required: true, rules: this.state.money_operator_id_rules }),
            this.getDownButtons()));
    };
    /*private getImportTabRenderObject(): JSX.Element {
        return (
            <div>

                <CardRowCheckBoxEditor
                    title={"Добавлять аттрибут 'новая игра'"}
                    value={this.state.ngm_is_new_flag}
                    onChecked={(checked) => {
                        this.setState({ ngm_is_new_flag: checked })
                    }}
                />

                <CardRowNumericEditor
                    texts={{ caption: "Процент в вейджер:", placeholder: "Введите процент в вейджер" }}
                    values={{ max: 100, min: 0, value: this.state.ngm_wager_percent }}
                    onValueChanged={(newVal) => {
                        this.setState({
                            ngm_wager_percent: newVal,
                            ngm_wager_percent_rules: { isError: false }
                        })
                    }}
                    required
                    rules={this.state.ngm_wager_percent_rules}
                />

                <CardRowNumericEditor
                    texts={{ caption: "Процент в снятие:", placeholder: "Введите процент в снятие" }}
                    values={{ max: 100, min: 0, value: this.state.ngm_withdraw_percent }}
                    onValueChanged={(newVal) => {
                        this.setState({
                            ngm_withdraw_percent: newVal,
                            ngm_withdraw_percent_rules: { isError: false }
                        })
                    }}
                    required
                    rules={this.state.ngm_withdraw_percent_rules}
                />

                <CardRowNumericEditor
                    texts={{ caption: "Процент в джекпот:", placeholder: "Введите процент в джекпот" }}
                    values={{ max: 100, min: 0, value: this.state.ngm_jackpot_percent }}
                    onValueChanged={(newVal) => {
                        this.setState({
                            ngm_jackpot_percent: newVal,
                            ngm_jackpot_percent_rules: { isError: false }
                        })
                    }}
                    required
                    rules={this.state.ngm_jackpot_percent_rules}
                />

                <CardRowNumericEditor
                    texts={{ caption: "Процент в турнир:", placeholder: "Введите процент в турнир" }}
                    values={{ max: 100, min: 0, value: this.state.ngm_tournament_percent }}
                    onValueChanged={(newVal) => {
                        this.setState({
                            ngm_tournament_percent: newVal,
                            ngm_tournament_percent_rules: { isError: false }
                        })
                    }}
                    required
                    rules={this.state.ngm_tournament_percent_rules}
                />

                <CardRowNumericEditor
                    texts={{ caption: "Процент в пойнты:", placeholder: "Введите процент в пойнты" }}
                    values={{ max: 100, min: 0, value: this.state.ngm_points_percent }}
                    onValueChanged={(newVal) => {
                        this.setState({
                            ngm_points_percent: newVal,
                            ngm_points_percent_rules: { isError: false }
                        })
                    }}
                    required
                    rules={this.state.ngm_points_percent_rules}
                />

                <CardRowNumericEditor
                    texts={{ caption: "Процент в уровни:", placeholder: "Введите процент в уровни" }}
                    values={{ max: 100, min: 0, value: this.state.ngm_levels_percent }}
                    onValueChanged={(newVal) => {
                        this.setState({
                            ngm_levels_percent: newVal,
                            ngm_levels_percent_rules: { isError: false }
                        })
                    }}
                    required
                    rules={this.state.ngm_levels_percent_rules}
                />

                {this.getDownButtons()}

            </div>
        )
    }*/
    GwsGameProviderCfgEditor.prototype.preViewTPL = function (tpl) {
        var _this = this;
        var template = Handlebars.compile(tpl);
        var rendered = template(JSON.parse(this.state.template_test));
        this.props.dialogViewText
            .SetTitle("Просмотр")
            .SetText(rendered)
            .SetOnCloseClick(function () { _this.props.dialogViewText.Close(); })
            .Show();
    };
    GwsGameProviderCfgEditor.prototype.getAdditionalTabRenderObject = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { description: "Money url template desktop:", placeholder: "Введите money url template desktop", buttonHint: "Preview" }, value: this.state.game_money_template_url_desktop, onValueChanged: function (newVal) {
                    _this.setState({
                        game_money_template_url_desktop: newVal,
                        game_money_template_url_desktop_rules: { isError: false }
                    });
                }, onButtonClick: function () {
                    _this.preViewTPL(_this.state.game_money_template_url_desktop);
                }, buttonIcon: "eye", required: true, rules: this.state.game_money_template_url_desktop_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { description: "Money url template mobile:", placeholder: "Введите money url template mobile", buttonHint: "Preview" }, value: this.state.game_money_template_url_mobile, onValueChanged: function (newVal) {
                    _this.setState({
                        game_money_template_url_mobile: newVal,
                        game_money_template_url_mobile_rules: { isError: false }
                    });
                }, onButtonClick: function () {
                    _this.preViewTPL(_this.state.game_money_template_url_mobile);
                }, buttonIcon: "eye", required: true, rules: this.state.game_money_template_url_mobile_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { description: "Demo url template desktop:", placeholder: "Введите demo url template desktop", buttonHint: "Preview" }, value: this.state.game_demo_template_url_desktop, onValueChanged: function (newVal) {
                    _this.setState({
                        game_demo_template_url_desktop: newVal,
                        game_demo_template_url_desktop_rules: { isError: false }
                    });
                }, onButtonClick: function () {
                    _this.preViewTPL(_this.state.game_demo_template_url_desktop);
                }, buttonIcon: "eye", required: true, rules: this.state.game_demo_template_url_desktop_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { description: "Demo url template mobile:", placeholder: "Введите demo url template mobile", buttonHint: "Preview" }, value: this.state.game_demo_template_url_mobile, onValueChanged: function (newVal) {
                    _this.setState({
                        game_demo_template_url_mobile: newVal,
                        game_demo_template_url_mobile_rules: { isError: false }
                    });
                }, onButtonClick: function () {
                    _this.preViewTPL(_this.state.game_demo_template_url_mobile);
                }, buttonIcon: "eye", required: true, rules: this.state.game_demo_template_url_mobile_rules }),
            this.getDownButtons()));
    };
    GwsGameProviderCfgEditor.prototype.onChange = function (newValue) {
        this.setState({ template_test: newValue });
    };
    GwsGameProviderCfgEditor.prototype.getTestTabRenderObject = function () {
        return (React.createElement("div", { style: {
                minHeight: "390px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start"
            } },
            React.createElement(react_ace_1.default, { mode: "json", theme: "sqlserver", onChange: this.onChange.bind(this), name: "UNIQUE_ID_OF_RECORD_CONTENT_DIV_TPL_TEST", editorProps: { $blockScrolling: true }, width: "100%", height: "330px", fontSize: 14, wrapEnabled: true, showPrintMargin: false, value: this.state.template_test, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this) })));
    };
    GwsGameProviderCfgEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainTabRenderObject();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalTabRenderObject();
        }
        //if (this.state.tabKey === this.key_import) {
        //    return this.getImportTabRenderObject();
        //}
        if (this.state.tabKey === this.key_test) {
            return this.getTestTabRenderObject();
        }
        return null;
    };
    GwsGameProviderCfgEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    GwsGameProviderCfgEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 740, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" },
                { key: this.key_test, tab: "Тест" }
            ], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return GwsGameProviderCfgEditor;
}(React.Component));
exports.default = GwsGameProviderCfgEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ui/component/GwsGameProviderCfgEditor.tsx
// module id = 1860
// module chunks = 0